import React from "react";
import ReactDOM from "react-dom/client";

import { CookiesProvider } from "react-cookie";
import { QueryClientProvider } from "./QueryClientProvider";
import { Toaster } from "react-hot-toast";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import "./sentry";

import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "@fontsource/ibm-plex-sans-arabic/700.css";
import "./index.css";
import "./theme/themeStore";
import { Router } from "./router";
import { APIsProvider } from "./api";
import { AuthProvider } from "./Auth";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Toaster
      toastOptions={{
        // The S tokens, so toasts follow the theme.
        style: {
          background: "var(--popover)",
          color: "var(--popover-foreground)",
          border: "1px solid var(--border)",
          boxShadow: "var(--card-shadow)",
          borderRadius: "calc(var(--radius) * 0.8)",
          fontSize: "14px",
        },
        success: { iconTheme: { primary: "var(--success)", secondary: "var(--popover)" } },
        error: { iconTheme: { primary: "var(--destructive)", secondary: "var(--popover)" } },
      }}
    />
    <CookiesProvider>
      <QueryClientProvider>
        <ReactQueryDevtools initialIsOpen={false} />
        <APIsProvider>
          <AuthProvider>
            <Router />
          </AuthProvider>
        </APIsProvider>
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>,
);
